import React, { useEffect, useState } from 'react'
import Header from './Layouts/Header'
import Sidebar from './Layouts/Sidebar'
import axios from 'axios'
import { SERVER_URL } from '../Config'

function Users() {
  const[Users,setUsers] = useState([])
  const storedPrices = JSON.parse(localStorage.getItem('prices'));
  const users = async()=>{
    try{
     setUsers([
      {
        name:"Ethereum",'symbol':"ETH",contract_Address:"0xEeeEeeEeeeeEeeeeeeeeeeEeeeeEe",image:"/assets/img/icon/dash-icon-02.svg",price:storedPrices['ETH'],status:"Active"
      },
      {
        name:"Binance Coin",'symbol':"BNB",contract_Address:"0xEeeEeeEeeeeEeeeeeeeeeeEeeeeEe",image:"https://cdn3d.iconscout.com/3d/premium/thumb/binance-crypto-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--symbol-sign-logo-coin-glossy-pack-science-technology-illustrations-3591027.png?f=webp",price:storedPrices['BNB'],status:"Active"
      },
      {
        name:"Tron (TRX)",'symbol':"TRX",contract_Address:"0xEeeEeeEeeeeEeeeeeeeeeeEeeeeEe",image:"https://cdn3d.iconscout.com/3d/premium/thumb/tron-trx-badge-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--cryptocurrency-symbol-crypto-badges-vol-1-pack-science-technology-illustrations-4414723.png?f=webp",price:storedPrices['TRX'],status:"Active"
      },
      {
        name:"Polygon",'symbol':"POL",contract_Address:"0xEeeEeeEeeeeEeeeeeeeeeeEeeeeEe",image:"https://cdn-icons-png.flaticon.com/512/6001/6001527.png",price:storedPrices['MATIC'],status:"Active"
      },
      {
        name:"Solana",'symbol':"SOL",contract_Address:"0xEeeEeeEeeeeEeeeeeeeeeeEeeeeEe",image:"https://cryptologos.cc/logos/polygon-matic-logo.png",price:storedPrices['SOL'],status:"Active"
      }
     ])
    }catch(err){
      console.log(err)
      setUsers([])
    }
  }
  useEffect(()=>{
    users()
  },[])
  console.log(Users,'users')
  return (
    <div>
      <>
      <Header/>
      <Sidebar/>
  <div className="page-wrapper bg-wrapper">
    <div className="content">
      <div className="buy-form">
        <div className="row">
          <div className="col-sm-4 col-3">
            <h4 className="page-title">Basecoins List</h4>
          </div>
          {/* <div className="col-sm-8 col-9 text-end m-b-20">
            <a
              href="add-employee.html"
              className="btn btn-primary float-right btn-rounded"
            >
              <i className="fas fa-plus" /> Add Employee
            </a>
          </div> */}
        </div>
        {/* <div className="row filter-row">
          <div className="col-sm-6 col-md-3">
            <div className="form-group">
              <label className="focus-label">User Name</label>
              <input type="text" className="form-control" />
            </div>
          </div>
          <div className="col-sm-6 col-md-3">
            <div className="form-group">
              <label className="focus-label">User Email</label>
              <input type="text" className="form-control" />
            </div>
          </div>
          <div className="col-sm-6 col-md-3">
            <div className="form-group bg-hover select-focus">
              <label className="focus-label">Role</label>
              <select className="select floating">
                <option>Select Role</option>
                <option>Staff</option>
                <option>Staff</option>
                <option>Staff</option>
                <option>Accountant</option>
                <option>Receptionist</option>
              </select>
            </div>
          </div>
          <div className="col-sm-6 col-md-3">
            <a
              href="employees.html#"
              className="btn btn-success btn-block mt-4 mb-1"
            >
              {" "}
              Search{" "}
            </a>
          </div>
        </div> */}
        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-striped custom-table">
                <thead>
                  <tr>
                    <th style={{ minWidth: 200 }}>Name</th>
                    <th>Coin Name</th>
                    <th>Coin Symbol</th>
                    <th style={{ minWidth: 110 }}>Contract Address</th>
                    <th style={{ minWidth: 110 }}>Logo</th>
                    <th style={{ minWidth: 110 }}>Price</th>
                    <th style={{ minWidth: 110 }}>Status</th>
                  </tr>
                </thead>
                <tbody>

                  {/* <tr>
                    <td>
                      <img
                        width={28}
                        height={28}
                        src="/assets/img/user.jpg"
                        className="rounded-circle"
                        alt=""
                      />{" "}
                      <h2>Albina Simonis</h2>
                    </td>
                    <td>SF-0001</td>
                    <td>
                      <a
                        href="../../../cdn-cgi/l/email-protection"
                        className="__cf_email__"
                        data-cfemail="cdaca1afa4a3acbea4a0a2a3a4be8da8b5aca0bda1a8e3aea2a0"
                      >
                        [email&nbsp;protected]
                      </a>
                    </td>
                    <td>828-634-2744</td>
                    <td>7 May 2015</td>
                    <td>
                      <span className="custom-badge status-green">Staff</span>
                    </td>
                    <td className="text-end">
                      <div className="dropdown dropdown-action">
                        <a
                          href="employees.html#"
                          className="action-icon dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="fas fa-ellipsis-v" />
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                          <a
                            className="dropdown-item"
                            href="edit-employee.html"
                          >
                            <i className="fas fa-pencil-alt m-r-5" /> Edit
                          </a>
                          <a
                            className="dropdown-item"
                            href="employees.html#"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_employee"
                          >
                            <i className="fas fa-trash-alt m-r-5" /> Delete
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr> */}
                  {Users && Users.length > 0 ? (
                    Users.map((data, index) => (
                      <tr key={index + 1}>
                        <td>{index + 1}</td>
                        <td>
                          {data.name}
                        </td>
                        <td>{data.symbol}</td>
                        <td>{data.contract_Address}</td>
                        <td>
                          <img width="50" src={data.image}/>
                        </td>
                        <td>{data.price}...</td>
                        <td ><span className="custom-badge status-green">Active</span></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="notification-box">
      <div className="msg-sidebar notifications msg-noti">
        <div className="topnav-dropdown-header">
          <span>Messages</span>
        </div>
        <div className="drop-scroll msg-list-scroll" id="msg_list">
          <ul className="list-box">
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">R</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author">Richard Miles </span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item new-message">
                  <div className="list-left">
                    <span className="avatar">J</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author">John Doe</span>
                    <span className="message-time">1 Aug</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">T</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author"> Tarah Shropshire </span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">M</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author">Mike Litorus</span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">C</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author"> Catherine Manseau </span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">D</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author"> Domenic Houston </span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">B</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author"> Buster Wigton </span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">R</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author"> Rolland Webber </span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">C</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author"> Claire Mapes </span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">M</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author">Melita Faucher</span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">J</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author">Jeffery Lalor</span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">L</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author">Loren Gatlin</span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <a href="chat.html">
                <div className="list-item">
                  <div className="list-left">
                    <span className="avatar">T</span>
                  </div>
                  <div className="list-body">
                    <span className="message-author">Tarah Shropshire</span>
                    <span className="message-time">12:28 AM</span>
                    <div className="clearfix" />
                    <span className="message-content">
                      Lorem ipsum dolor sit amet, consectetur adipiscing
                    </span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div className="topnav-dropdown-footer">
          <a href="chat.html">See all messages</a>
        </div>
      </div>
    </div>
  </div>
  <div id="delete_employee" className="modal fade delete-modal" role="dialog">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-body text-center">
          <img src="/assets/img/sent.png" alt="" width={50} height={46} />
          <h3>Are you sure want to delete this Employee?</h3>
          <div className="m-t-20">
            {" "}
            <a
              href="employees.html#"
              className="btn btn-white"
              data-bs-dismiss="modal"
            >
              Close
            </a>
            <button type="submit" className="btn btn-danger">
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</>

    </div>
  )
}

export default Users
